// Frozen pre-upgrade baseline. Never infer support for a new command from v1.
const LEGACY_TYPES = new Set(['warehouse.create', 'warehouse.update', 'warehouse.delete', 'supplier.create', 'supplier.update', 'supplier.delete', 'product-suppliers.update', 'stock-item.create', 'stock-item.update', 'stock-item.delete', 'stock-item.packaging', 'stock-item.revalue', 'stock-item.warehouse', 'stock-item.ensure-link', 'extra.ensure-resold-stock-item', 'purchase-order.create', 'purchase-order.update', 'purchase-order.delete', 'purchase-order.cancel', 'purchase-order.status', 'purchase-order.receive', 'recipe.create', 'recipe.update', 'recipe.delete', 'inventory.create', 'inventory.count', 'inventory.count-delete', 'inventory.finalize', 'inventory.cancel', 'loss.create', 'loss.validate', 'loss.refuse', 'stock-setting.create', 'stock-setting.update', 'stock-setting.delete']);
function supportsWaiseCommand(capabilities, type, expectedRevision = null, payload = {}) {
  const values = new Set(capabilities || []);
  if (!values.has('waise_commands_v1')) return false;
  if (payload._waise_packaging != null && !values.has('waise_stock_bundle_v1')) return false;
  if (String(expectedRevision || '').startsWith('rev1:') && !values.has('waise_revision_v1')) return false;
  return values.has('waise_command_types_v1') ? values.has(`waise_command:${type}`) : LEGACY_TYPES.has(type);
}
function parseWaiseClaimantCapabilities(header) {
  if (header == null) return ['waise_commands_v1'];
  try {
    const values = JSON.parse(header);
    return Array.isArray(values) && values.length <= 128 && values.every(value => typeof value === 'string') ? values : [];
  } catch (_) {
    return [];
  }
}
module.exports = {
  supportsWaiseCommand,
  parseWaiseClaimantCapabilities
};
